import { isTouchDisplay } from "~/const/device";
import { G_PlayDevice, G_Device } from "~/lib/graphql";
import { isBot } from "~/util/is-bot";

/**
 * ユーザーの利用デバイスを取得する処理
 */
export const getDevice = () => {
  if (isBot()) return G_Device.BrowserMobileAndroid;
  if (isTouchDisplay && navigator.vendor === "Apple Computer, Inc.") return G_Device.BrowserMobileIos;
  if (isTouchDisplay && navigator.vendor === "Google Inc.") return G_Device.BrowserMobileAndroid;

  return G_Device.Browser;
};

/**
 * 動画再生デバイスを取得する処理
 */
export const getPlayDevice = () => {
  if (isBot()) return G_PlayDevice.BrowserMobileAndroid;
  if (isTouchDisplay && navigator.vendor === "Apple Computer, Inc.") return G_PlayDevice.BrowserMobileIos;
  if (isTouchDisplay && navigator.vendor === "Google Inc.") return G_PlayDevice.BrowserMobileAndroid;

  return G_PlayDevice.Browser;
};
